export const REGIMEN_FIELD_INFO = {
  name: {
    required: true,
    description: 'Enter the name of your regimen. This helps you identify and track different protocols.'
  },
  type: {
    required: true,
    description: 'Select the type of substance or activity for this regimen.'
  },
  dosage: {
    required: false,
    description: 'The amount to be administered per dose.'
  },
  timing: {
    required: true,
    description: 'When during the day this regimen should be followed.'
  },
  frequency_interval: {
    required: true,
    description: 'How often the regimen should be repeated (e.g., every 1 day, every 12 hours).'
  },
  doses_per_interval: {
    required: false,
    description: 'How many doses per interval. (e.g. 2 doses every week)'
  },
  days_on: {
    required: false,
    description: 'Number of consecutive days to follow the regimen before taking a break.'
  },
  days_off: {
    required: false,
    description: 'Number of rest days between active periods.'
  },
  duration_period: {
    required: true,
    description: 'Total length of time to follow this regimen.'
  },
  duration_repeat: {
    required: false,
    description: 'How long to wait before starting the regimen again. Check "Never repeat" if this is a one-time regimen.'
  },
  notes: {
    required: false,
    description: 'Any additional notes or instructions for this regimen.'
  },
  dosage_level: {
    required: false,
    description: 'Indication relative to standard, e.g. low, standard, high.'
  },
  dosage_type: {
    required: false,
    description: 'The type of dose, e.g. baseline, loading, maintenance, baseline.'
  },
  source: {
    required: false,
    description: 'URL linking to source this information.'
  }
} as const;

export const CURRENT_PLAN_FIELD_INFO = {
  ...REGIMEN_FIELD_INFO,
  start_date: {
    required: true,
    description: 'Start date for this regimen'
  },
} as const;

export const SUGGESTED_DOSAGE_FIELD_INFO = {
  ...REGIMEN_FIELD_INFO,
  reconstitution_units: {
    required: false,
    description: 'The units used for reconstitution, e.g., mL or IU.'
  },
  syringe_units_per_dose: {
    required: false,
    description: 'The number of units in a syringe for each dose.'
  },
  reconstitution_amount: {
    required: false,
    description: 'The total amount of diluent used for reconstitution.'
  },
  amount_units: {
    required: false,
    description: 'The units of the total vial amount, e.g., mg or IU.'
  },
  amount: {
    required: false,
    description: 'The total amount contained in the vial.'
  }
} as const;
